module.exports = __webpack_public_path__ + "img/selected4-min.3749d389.png";